import { useNavigate } from "react-router-dom";
import PageSEO from "@/components/base/PageSEO";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-ivory-50 px-4">
      <PageSEO
        title="404 — Page Not Found | Sunshine Real Estate"
        description="The page you are looking for does not exist. Browse our verified real estate projects or contact us for investment guidance."
        noIndex
      />
      <div className="text-center max-w-md">
        <div className="w-20 h-20 flex items-center justify-center rounded-full bg-brand-orange/10 text-brand-orange mx-auto mb-6">
          <i className="ri-error-warning-line text-3xl" />
        </div>
        <h1 className="text-5xl md:text-6xl font-extrabold text-charcoal-300 mb-3">404</h1>
        <h2 className="text-xl md:text-2xl font-bold text-charcoal-300 mb-3">Page Not Found</h2>
        <p className="text-sm md:text-base text-charcoal-50 mb-8">
          The page you are looking for does not exist or has been moved. Let us help you find the right path.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-brand-orange text-white text-sm font-semibold rounded-lg hover:bg-brand-orangeLight transition-colors shadow-md"
          >
            Back to Home
          </button>
          <button
            onClick={() => navigate('/projects')}
            className="px-6 py-3 border border-charcoal-200 text-charcoal-300 text-sm font-semibold rounded-lg hover:bg-ivory-100 transition-colors"
          >
            View Projects
          </button>
        </div>
      </div>
    </div>
  );
}